import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppConstants from '../Constants/AppConstants';
import {messages} from '../Localization/catalogs';

const currentLocale = () => String(AppConstants.appLanguage || 'en').toLowerCase().split(/[-_]/)[0];

const localizedDefault = (key, fallback) => {
  const locale = currentLocale();
  return messages[locale]?.[key] || messages.en?.[key] || fallback;
};

const localizedMessage = message =>
  typeof message === 'string'
    ? message === 'Uploaded successfully' || message === 'uploaded'
      ? localizedDefault('common.uploaded_successfully', 'Uploaded successfully')
      : messages[currentLocale()]?.[message] || message
    : message;

const toastOptions = (autoClose = 4000) => ({
  position: 'bottom-right',
  autoClose,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
});

export function AppToast(type, msg) {
  if (type === 'delete') return toast.error(localizedDefault('common.deleted', 'Deleted'), toastOptions());
  if (type === 'Copied') return toast.success(localizedDefault('common.copied', 'Copied'), toastOptions());
  if (type === 'success') return toast.success(msg ? localizedMessage(msg) : localizedDefault('common.success', 'Success'), toastOptions());
  if (type === 'error') return toast.error(msg ? localizedMessage(msg) : localizedDefault('common.something_went_wrong', 'Something went wrong'), toastOptions(7000));
  if (type === 'warning') return toast.warn(msg ? localizedMessage(msg) : localizedDefault('common.toast.please_check_action', 'Please check this action'), toastOptions(6000));
  if (type === 'info') return toast.info(msg ? localizedMessage(msg) : localizedDefault('common.information', 'Information'), toastOptions());
  if (type?.status === false) return toast.error(localizedDefault('common.something_went_wrong', 'Something went wrong'), toastOptions(7000));
  if (type !== undefined && type !== null) return toast.info(localizedMessage(String(type)), toastOptions(6000));
  return toast.success(localizedDefault('common.success', 'Success'), toastOptions());
}
